import { useTooltip } from '#hooks/UNSAFE_useTooltip';

type Props = {
  isReadonly?: boolean;
  isDisabled?: boolean;
  tooltip?: string;
};

export function useRatingTooltip({ isReadonly, isDisabled, tooltip }: Props) {
  const text = isReadonly && !isDisabled ? tooltip : '';

  const { tooltipContent, tooltipProps } = useTooltip({ text, isDisabled });

  return {
    tooltipContent,
    tooltipProps:
      !isDisabled && isReadonly
        ? tooltipProps
        : {
            'aria-describedby': undefined
          }
  };
}
